import constants from "./constants";
export function userlogo(name) {
  let userLogo = name
    ? name
        .split(" ")
        .map((n) => n[0])
        .join("")
    : "";
  return userLogo == "" ? "AB" : userLogo;
}

export function formatListEquipNo(data) {
  let seperated = "";
  for (let obj of data) {
    seperated = seperated + "," + obj.EquipmentNumber;
  }
  seperated = seperated.slice(1);
  return seperated;
}

export function formatListProcedureRef(data) {
  let seperated = "";
  for (let obj of data) {
    seperated =
      seperated +
      "," +
      obj.ProcedureReference +
      " " +
      obj.RevisionNo +
      " " +
      obj.RevisionDate +
      " " +
      obj.ApplicableIn;
  }
  seperated = seperated.slice(1);
  return seperated;
}

export function updateOfferStatus(value) {
  let status = "";
  if (value === constants.PENDING_FOR_OFFER) {
    status = "Offer Not Created";
  } else {
    status = "Offer Created";
  }
  return status;
}

export function validIndicatorStatus(data,header,item) {
  // console.log("in");
  // console.log("dataa", item);
  if (item.validIndicator === "Y") {
    return constants.ACTIVE;
  } else {
    return constants.INACTIVE;
  }
}
// data.display === 'Yes' ? constants.ACTIVE : constants.INACTIVE
// return constants.ACTIVE;

export function validateEmail (value) {
  let isError = "";
  let pattern = /^[a-zA-Z0-9.]+@godrej\.com$/;
  let regex = new RegExp(pattern);
  if (!regex.test(value)) {
      isError = "Please enter a valid email address in the format XYZ@godrej.com";
  }
  return isError;
};
